import React, { useEffect, useState } from 'react'
import Lottie from 'react-lottie-player'

import cx from 'classnames'

import { YANADOO_CDN_HOST } from 'common/config'

import s from './ChatFooterAudio.module.scss'
import { CHAT_COMPONENTS_CONFIG } from './config'

const defaultOptions = {
  loop: true,
  play: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

export default function RecorderButton({
  isListening,
  isLoading,
  isActive,
  onClickAbort,
  onClickStart,
  onClickReStart,
  onClickSendMessage
}) {
  const [lottieData, setLottieData] = useState(null)

  useEffect(() => {
    const fetchLottieData = async () => {
      try {
        const response = await fetch(`${YANADOO_CDN_HOST}/lottie/aitalk-loading-spinner-bar.json`)
        const jsonData = await response.json()
        setLottieData(jsonData)
      } catch (error) {
        console.error('Lottie 데이터를 불러오는데 실패했습니다:', error)
      }
    }
    fetchLottieData()
  }, [])

  return (
    <>
      {isListening ? (
        <div className={s.controlButtons}>
          <button className={s.buttonCancel} onClick={onClickAbort}>
            취소
          </button>
          <button className={s.buttonMic} onClick={onClickSendMessage} disabled={isLoading}>
            <div>{CHAT_COMPONENTS_CONFIG.svg.send}</div>
          </button>
          <button className={s.buttonRestart} onClick={onClickReStart}>
            <span>재시작</span>
          </button>
        </div>
      ) : isLoading ? (
        <div className={cx(s.buttonMic, s.buttonLoading)}>
          <div className={s.loading}>
            <Lottie {...defaultOptions} animationData={lottieData} />
          </div>
        </div>
      ) : (
        <button
          className={s.buttonMic}
          onClick={onClickStart}
          disabled={isActive ? isActive : isLoading}
        >
          <div>
            {isActive ? CHAT_COMPONENTS_CONFIG.svg.disabled : CHAT_COMPONENTS_CONFIG.svg.mic}
          </div>
        </button>
      )}
    </>
  )
}
